import React from "react";

type IconProps = {
  size?: number | string;
  color?: string;
};

export const IconPlayMobile = ({ size, color }: IconProps): JSX.Element => {
  return (
    <svg
      width={size || "24"}
      height={size || "24"}
      viewBox="0 0 24 24"
      fill={color || "white"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00977 2.00002C7.53759 2.00181 8.05582 2.14318 8.51172 2.4092L20.5059 9.40529C20.96 9.6688 21.3384 10.0471 21.6006 10.502C21.8628 10.9569 22.0005 11.473 22.001 11.9981C22.0014 12.5231 21.864 13.0389 21.6025 13.4942C21.3738 13.8926 21.0573 14.2325 20.6777 14.4883L20.5117 14.5928L8.51172 21.5928C8.0559 21.8587 7.53746 21.9992 7.00977 22.001C6.48212 22.0027 5.9634 21.8654 5.50586 21.6026C5.04822 21.3397 4.66767 20.9607 4.40332 20.5039C4.13896 20.047 3.99984 19.5279 4 19V5.00099C3.99984 4.47327 4.1391 3.95487 4.40332 3.49806C4.66768 3.04117 5.04815 2.66139 5.50586 2.39845C5.96338 2.13569 6.48216 1.9983 7.00977 2.00002Z"
        fill={color || "white"}
      />
    </svg>
  );
};

export default IconPlayMobile;
